var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacherList"},_vm._l((_vm.RecommendCourse.teacherList),function(item,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(item.name)+_vm._s(index != _vm.RecommendCourse.teacherList.length - 1 ? '、' : '')+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }